import project1 from "../assets/images/engaz.png";
import project2 from "../assets/images/healthy.png";
import project3 from "../assets/images/elnoor.png";
import project_R_1 from "../assets/images/portfolio.png";
import project_R_2 from "../assets/images/todo.png";
import project_W_1 from "../assets/images/tases.png";
import project_W_2 from "../assets/images/resal.png";
import project_W_3 from "../assets/images/waffy.png";
import project_W_4 from "../assets/images/centraly.png";
import project_W_5 from "../assets/images/shabakat.png";
import project_F_1 from "../assets/images/pump-fit.jpg";
import project_S_1 from "../assets/images/ai-hero-1.png";
import project_S_1_thumb from "../assets/images/ai-hero-1-thumb.jpg";


const projects = {
  html: [
    {
      id: 1,
      type: "html",
      image: project1,
      path: "/projects/html/engaz/index.html",
      title: "Engaz HTML Template",
      description:
        "A modern and fully responsive HTML template built from scratch and sold successfully on TemplateMonster. Designed with clean code, smooth animations, and optimized for fast loading and mobile-friendly experience.",
      tags: ["#HTML", "#CSS", "#JavaScript"],
    },
    {
      id: 2,
      type: "html",
      image: project2,
      path: "/projects/html/healthy/index.html",
      title: "Healthy HTML Template",
      description:
        "A clean and modern HTML template designed for health and wellness websites. Fully responsive, lightweight, and optimized for fast performance. Successfully sold on TemplateMonster, with attention to accessibility and user-friendly layout.",
      tags: ["#HTML", "#CSS", "#JavaScript"],
    },
    {
      id: 3,
      type: "html",
      image: project3,
      path: "/projects/html/el-noor_trips/index.html",
      title: "El Noor Trips",
      description:
        "A modern and fully responsive travel website template built for El Noor Trips company, offering stunning destinations, detailed tour packages, and easy booking options. Designed with clean HTML, CSS, and JavaScript for a smooth and engaging user experience.",
      tags: ["#HTML", "#CSS", "#JavaScript"],
    },

  ],
  react: [
    {
      id: 1,
      type: "react",
      image: project_R_1,
      path: "https://www.abdallasaleh.site",
      title: "Portfolio Template",
      description:
        "A personal portfolio template built with React and CSS, used to showcase various projects in an organized and visually appealing way.",
      tags: ["#React", "#CSS"],
    },

    {
      id: 2,
      type: "react",
      image: project_R_2,
      path: "https://to-do-five-umber-56.vercel.app",
      title: "To-Do List App",
      description:
        "A simple and responsive to-do list application built with React and plain CSS, allowing users to add, edit, mark as completed, and delete tasks with data persistence in localStorage.",
      tags: ["#React", "#CSS"],
    },
  ],
  wordpress: [
    {
      id: 1,
      type: "wordpress",
      image: project_W_1,
      flag: "special",
      path: "https://tasesdigital.com/",
      title: "Tasesdigital Company",
      description:
        "developed the Tases Digital website as a modern digital platform designed to showcase the company’s services and solutions in a clear and engaging way.",
      tags: ["#Wordpress", "#Greenshift"],
    },
    {
      id: 2,
      type: "wordpress",
      image: project_W_2,
      flag: "special",
      path: "https://www.resal.me/",
      title: "Resal Platform",
      description:
        "Developed and contributed to the Resal digital gifting platform, building a seamless and engaging user experience for discovering, purchasing, and sending digital gift cards. Focused on translating product requirements into scalable, user-friendly interfaces while maintaining clean, efficient, and reliable code.",
      tags: ["#Wordpress", "#Greenshift"],
    },
    {
      id: 3,
      type: "wordpress",
      image: project_W_3,
      flag: "special",
      path: "https://waffyapp.com/",
      title: "Waffy Platform",
      description:
        "A fintech website built with WordPress (Gutenberg), Greenshift, and Blocksy, designed to present a secure escrow platform with a clean, structured, and conversion-focused user experience.",
      tags: ["#Wordpress", "#Greenshift"],
    },

    {
      id: 4,
      type: "wordpress",
      image: project_W_4,
      flag: "special",
      path: "https://centraly.com.sa/ar/",
      title: "Centraly",
      description:
        "A modern platform designed to streamline communication management by integrating call center systems, CRM, and WhatsApp conversations into one unified and structured workflow.",
      tags: ["#Wordpress", "#Greenshift"],
    },
    {
      id: 5,
      type: "wordpress",
      image: project_W_5,
      flag: "special",
      path: "https://dev.tasesdigital.com/shabakat/",
      title: "Shabakat W Akthr",
      description:
        "A professional website for an established IT and networking company, designed to showcase integrated technology solutions, extensive product offerings, and expertise in building stable, high-performance network infrastructures.",
      tags: ["#Wordpress", "#Greenshift"],
    },
  ],
  webflow: [
    {
      id: 1,
      type: "webflow",
      image: project_F_1,
      flag: "special",
      path: "https://gym-1757ac.webflow.io/",
      title: "Pump Fitness Club",
      description:
        "Pump Fit Club is a modern gym website built using Webflow, designed to deliver a clean and dynamic user experience. The site showcases the gym’s services, programs, pricing, and client testimonials through a visually strong layout and smooth interactions. It features responsive design, scroll-based animations, and a structured Webflow build that makes the experience fast, intuitive, and engaging across all devices.",
      tags: ["#Webflow"],
    },

  ],
  section: [
    {
      id: 1,
      type: "section",
      image: project_S_1,
      thumb: project_S_1_thumb,
      flag: "section",
      path: "/projects/sections/ai-section/index.html",
      title: "Ai Hero Section",
      description:
        "A modern, responsive Hero Section designed for AI / SaaS / Tech products. Built using pure HTML & CSS with smooth animations, glassmorphism button effects, and animated AI-style gradient text.",
      tags: ["#section", "#HTML", "#CSS"],
    },
  ]
};

export default projects;
